import React from "react";

export const useDiscountHandler = (totalAmount: number, setCondition: React.Dispatch<React.SetStateAction<number>>) => {
  const handleDiscountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    if (Number(value) >= totalAmount) {
      e.target.value = value.slice(0, -1);
      return;
    }
    if (value === "") {
      setCondition(0);
      return;
    }
    if (value.length > 1 && value.startsWith("0")) {
      value = value.replace(/^0+/, "");
      e.target.value = value;
    }

    const numericValue = Number(value);
    if (numericValue >= 0 && numericValue < totalAmount) {
      setCondition(numericValue);
    } else {
      setCondition(0);
    }
  };

  return handleDiscountChange;
};
